module.exports = __webpack_public_path__ + "static/media/adaptability.07bf47aa.png";